import React, { useEffect } from 'react'
import cookie from 'react-cookies'
import {getDingDingAppId,getDDCodeLoginRequestDomain } from "../utils";

const CodeLogin = (props) => {
    const { jumpUrl, iPV4, appid, networkIP, requestId,isReturnSubordinate} = props
    const urlParams = {
        type: 'ScanCode',
        url: jumpUrl,
        ip: iPV4,
        appId: appid
    }
    const loginDomain = getDDCodeLoginRequestDomain('');
    const dingdingAppKey = getDingDingAppId();
    const { type, url, ip, appId } = urlParams
    
    const redirectUrl = encodeURIComponent(`${loginDomain}/api/CodeLogin/ScanCodeLogin?type=${type}&url=${url}&ip=${ip}&appId=${appId}&ati=${cookie.load("_ati")}&netWorkIP=${networkIP}&clientIp=${iPV4}&requestCid=${requestId}`)

    const goto = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${dingdingAppKey}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${redirectUrl}`
    console.log("goto:" + goto);             
    useEffect(() => {
        window.DDLogin({
            id: "code_container", //这里需要定义一个HTML标签并设置id
            goto: encodeURIComponent(goto),
            style: "border:none;background-color:#FFF;",
            width : "360",
            height: "300"
        })
        var handleMessage = function (event) {
            var origin = event.origin;
            console.log("origin", event.origin);
            if( origin === "https://login.dingtalk.com" ) { //判断是否来自ddLogin扫码事件。
              var loginTmpCode = event.data; 
              //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
              console.log("loginTmpCode", loginTmpCode);
              window.location.href = `${goto}&loginTmpCode=${loginTmpCode}`;
            }
        };
        if (typeof window.addEventListener != 'undefined') {
            window.addEventListener('message', handleMessage, false);
        } else if (typeof window.attachEvent != 'undefined') {
            window.attachEvent('onmessage', handleMessage);
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div>
            <div id='code_container'></div>
        </div>
    )
}
export default CodeLogin;
